import styled from "styled-components";
import {Typography, Table, Collapse} from "antd";

const {Text} = Typography;

export const PageWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 12px;
    }

    @media (max-width: 480px) {
        padding: 8px;
    }
`;

export const StyledTable = styled(Table)`
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
`;

export const StyledCollapse = styled(Collapse)`
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;
    width: 100%;
`;

export const HeaderWrapper = styled.div`
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        margin-bottom: 24px;
    }
`;

export const DateWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;

    @media (max-width: 768px) {
        width: 100%;

        .ant-picker {
            width: 100%;
        }
    }
`;

export const DetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const DetailLabel = styled(Text)`
    font-weight: bold;
    flex: 0 0 120px;
`;

export const DetailValue = styled(Text)`
    text-align: right;
    flex: 1;
    word-wrap: break-word;
    word-break: break-word;
    max-width: 70%;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 15px;
`;

export const EmptyWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 40px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AccountButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    z-index: 1000;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        justify-content: stretch;

        button {
            width: 100%;
        }
    }
`;

export const PaymentTypeContainer = styled.div`
    border: 1px solid #aef001;
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: white;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

export const PaymentTypeRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fafafa;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;
    box-sizing: border-box;

    &:hover {
        background-color: #f0f0f0;
    }

    @media (max-width: 768px) {
        padding: 10px 12px;
        flex-wrap: wrap;
    }

    @media (max-width: 480px) {
        padding: 8px 10px;
    }
`;

export const PaymentTypeInfo = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;

    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 12px;
    }
`;

export const PaymentTypeLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;

    @media (max-width: 768px) {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 4px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }

    & > div {
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }
`;

export const PaymentTypeCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;

    @media (max-width: 768px) {
        flex: 0 0 calc(50% - 6px);
        justify-content: flex-start;
    }

    span {
        white-space: normal;
    }
`;

export const PaymentTypeRight = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
    justify-content: flex-end;
    word-wrap: break-word;
    overflow-wrap: break-word;

    @media (max-width: 768px) {
        flex: 0 0 calc(50% - 6px);
        gap: 12px;
        justify-content: flex-end;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }

    span {
        white-space: normal;
    }
`;

export const OrderDetailHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: #f5f5f5;
    font-weight: bold;
    border-bottom: 1px solid #e8e8e8;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 8px 12px;
        font-size: 13px;
    }

    @media (max-width: 480px) {
        padding: 6px 10px;
        font-size: 12px;
    }

    & > div {
        flex: 1;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;

export const OrderDetailSection = styled.div`
    background-color: white;
    width: 100%;
    box-sizing: border-box;
`;

export const OrderDetailRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: white;
    border-bottom: 1px solid #f0f0f0;
    width: 100%;
    box-sizing: border-box;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        padding: 8px 12px;
        flex-wrap: wrap;
        gap: 8px;
    }

    @media (max-width: 480px) {
        padding: 6px 10px;
        gap: 4px;
    }

    & > div {
        flex: 1;
        min-width: 0;

        @media (max-width: 768px) {
            flex: 1 1 auto;
            max-width: 100%;
        }
    }

    & span {
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }
`;

export const ExpandedRowContent = styled.div`
    padding: 16px;
    border: 1px solid #aef001;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 8px;

    @media (max-width: 768px) {
        padding: 12px;
    }

    @media (max-width: 480px) {
        padding: 8px;
    }

    .ant-tabs {
        width: 100%;
        max-width: 100%;
    }

    .ant-tabs-content {
        width: 100%;
        max-width: 100%;
    }

    .ant-tabs-content-holder {
        overflow-x: visible;
    }

    .ant-tabs-nav {
        margin-bottom: 16px;
    }
`;

export const TabContentWrapper = styled.div`
    min-height: 200px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: visible;
`;
